<template>
  <div class="e-skill-tag">
    <slot />
  </div>
</template>
